/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M0 1c0-.5523.4477-1 1-1s1 .4477 1 1v.25h7V1c0-.5523.4477-1 1-1s1 .4477 1 1v.25h2c3.7279 0 6.75 3.022 6.75 6.75v7c0 .6904.5596 1.25 1.25 1.25h1V16c0-.5523.4477-1 1-1s1 .4477 1 1v7c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.25h-2c-1.3689 0-2.6426-.4075-3.7064-1.1077-.4624 1.2314-1.6507 2.1077-3.0436 2.1077H2.75C1.2312 23.75 0 22.5188 0 21v-8c0-1.5188 1.2312-2.75 2.75-2.75h10.5V9c0-.6904-.5596-1.25-1.25-1.25h-1V8c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.25H2V8c0 .5523-.4477 1-1 1s-1-.4477-1-1V1Zm20 20.25c-2.8995 0-5.25-2.3505-5.25-5.25V9c0-1.5188-1.2312-2.75-2.75-2.75h-1v-3.5h2c2.8995 0 5.25 2.3505 5.25 5.25v7c0 1.5188 1.2312 2.75 2.75 2.75h1v3.5h-2ZM2 2.75h7v3.5H2v-3.5Zm4.5303 12.7803a.75.75 0 0 0-1.0607-1.0606L2.9394 17l2.5304 2.5303a.75.75 0 0 0 1.0606-1.0606L5.0606 17l1.4697-1.4697Zm1.9394 4a.75.75 0 0 1 0-1.0606L9.9393 17l-1.4696-1.4697a.75.75 0 0 1 1.0607-1.0606L12.0606 17l-2.5304 2.5303a.75.75 0 0 1-1.0606 0Z"
    clipRule="evenodd"
  />,
  'MenuPipelinesFilled'
);
